export default {
  hytj:'Freight statistics',
  tjhz:'Statistical summary',
  qb:'Whole',
  fh:'Send out goods',
  sh:'Take delivery of goods',
  tjfs:'Statistical pattern',
  jyn:'In the past year',
  jyy:'In the past month',
  tjsjjzzr:'Statistical data as of yesterday',
  hwzz:'Total weight of goods',
  wd:'Million tons',
  tb:'YOY',
  hb:'QOQ',
  fhhwzz:'Total weight of shipped goods',
  shhwzz:'Total weight of received goods',
  ljxf:'Accumulated consumption',
  wy:'Ten thousand yuan',
  my:'dollar',
  jp:'Kip',
  zjfhjj:'Recent shipment date',
  zjshjj:'Recent receipt date',
  tian:'day',
  fwqy:'Service enterprises',
  zysfhwpl:'Main categories of receiving and shipping items',
  dw:'unit',
}
